import Analytics from '@module/analytics';

import initSnowplow from '@app/init/snowplow';
import Store from '@app/store';
import Actions from '@app/store/action';

export const createDefaultPayload = () => {
  const dataLayerPayload = {};

  if (window.__session__) {
    const session = window.__session__;
    dataLayerPayload.user = {
      account_type: session.user && session.user.id ? 'plus' : 'free',
      language: session.user && session.user.language,
      subdomain_name:
        session.profile && session.profile.subdomain_name
          ? session.profile.subdomain_name
          : null,
    };
  }

  // Preloaded transfer
  if (window._preloaded_transfer_) {
    const transfer = window._preloaded_transfer_;
    // Download page data
    dataLayerPayload.page = {
      download: {
        id: transfer.id,
        receiver_id: transfer.recipient_id,
        security_hash: transfer.security_hash,
        state: transfer.state,
      },
    };

    // VRL
    if (transfer.items && transfer.items.length) {
      const previewableItemsCount = transfer.items.filter(
        ({ previewable }) => previewable
      ).length;

      dataLayerPayload.page.VRL = !!previewableItemsCount;
      dataLayerPayload.transfer = {
        item_count: transfer.items.length,
        previewable_count: previewableItemsCount,
      };
    }
  }

  // Fake data layer because every time dataLayer.push is invoked, it's one extra event
  // As versus this approach, where the dataLayer is rather initialized with data
  return dataLayerPayload;
};

const startAnalytics = (snowplowReady) => {
  Analytics.configure({ snowplowReady });
  Analytics.trackGoogleEvent(createDefaultPayload());
};

export const init = () =>
  new Promise((resolve) => {
    initSnowplow((domainUserId) => {
      Store.dispatch(Actions.Session.setDomainUserId(domainUserId));
      resolve();
    });
  })
    .then(() => startAnalytics(true))
    // ignore errors and continue with Analytics without Snowplow
    .catch(() => startAnalytics(false));
